import React from "react";

import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import SVGComponent from "../../SVGComponent";

/**
@param {string} props.TitleNameColour,  - title color class for HeaderName eg:- "text-primary"
@param {string} props.TitleAccountTextSize - title font size should be as per headerName eg:- font-sm , fon_md
@param {string} props.TitleAccountFontWeight - Subheading font size 
@param {string} props.SubTitleNameColour - Subheading font colour
@param {string} props.SubTitleAccountTextSize - Subheading font text-size
@param {string} props.SubTitleAccountFontWeight - Subheading Font weight
@param {string} props.TitleName - Second div title name
@param {string} props.SubTitleName - Second div Subheading  title name
@param {string} props.RightDivIcon - Third div icon 
@param {OnClickEventHandler} props.viewdetailsData - All details required to show on cards
@param {opacity} props.viewdetailsData - Opacity for card  e.g:- dark opacity ,light opacity , base opacity
@param {pointerEvent} props.pointerEvent - pointerEvent for card  e.g:- none , auto
@param {border} props.BorderColour -  give border to entire card
@param {border} props.bankLogo -  bank logo needed or not 
*/

const AssociatedAccountCard = ({
  TitleNameColour,
  TitleAccountTextSize,
  TitleAccountFontWeight,
  SubTitleNameColour,
  SubTitleAccountTextSize,
  SubTitleAccountFontWeight,
  TitleName,
  RightDivIcon,
  SubTitleName,
  FirstDivIcon,
  viewdetailsData,
  CardOpacity,
  pointerEvent,
  BorderColour,
  bankLogo,
}) => {
  return (
    <div
      className={`bg-primary-nav global-hover-white relative z-z-index-base ${BorderColour ? " border-borderthickness border-emphasis" : ""} rounded-border-radius-md `}
      style={{
        opacity: CardOpacity,
        pointerEvents: pointerEvent,
      }}
    >
      <div className=" flex ">
        {bankLogo && (
          <div className=" px-padding-sm flex items-center justify-center rounded-l-border-radius-md bg-text-primary flex-shrink-0">
            <CommonBankLogo
              ifsc={FirstDivIcon}
              variant="small"
            />
          </div>
        )}
        <div
          className={`py-padding-sm ${bankLogo ? "pl-padding-sm" : "pl-padding-md"} gap-gap-xs  flex flex-col truncate flex-1`}
        >
          <p
            className={`text-${TitleNameColour} truncate text-${TitleAccountTextSize} font-${TitleAccountFontWeight}`}
          >
            {TitleName.toLowerCase()
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")}
          </p>
          <p
            className={`text-${SubTitleNameColour} truncate text-${SubTitleAccountTextSize} font-${SubTitleAccountFontWeight}`}
          >
            {SubTitleName}
          </p>
        </div>
        <div className=" px-padding-sm cursor-pointer flex flex-col my-margin-sm items-center justify-center flex-shrink-0">
          <div
            onClick={() => {
              viewdetailsData();
            }}
            className=" border-l border-primary-bg gap-gap-xs py-padding-xs cursor-pointer pl-padding-sm flex flex-col items-center justify-between"
          >
            {" "}
            <SVGComponent
              url={RightDivIcon}
              width="var(--icon-md)"
              height="var(--icon-md)"
              color="var(--text-primary)"
            />
            <p className=" text-text-primary text-font-xxs font-normal">
              View details
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssociatedAccountCard;
